import { render, staticRenderFns } from "./UsuarioFirma.vue?vue&type=template&id=13b35c0b"
import script from "./UsuarioFirma.vue?vue&type=script&lang=js"
export * from "./UsuarioFirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports